import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IconButton, Modal } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/app-login.scss';
import Color from '@tool/color';
import AppPortal from './app-portal';
import Login from '@page/login/login';
import moLogin, { toggleLogin } from '@store/login';
import { CloseIcon } from '@styled/icon';
interface IProps {
  hideClose?: boolean,
  onChangeClose?: any
}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  right: '10px',
  top: '10px',
  width: '40px',
  height: '40px',
  padding: 0,
}));

const AppLogin = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { hideClose, onChangeClose } = props;
  const { loginModal } = moLogin;

  useEffect(() => {
    return () => {};
  }, []);

  const onClose = () => {
    toggleLogin(false);
    if(onChangeClose){
      onChangeClose()
    }
  };

  return (
    <Modal open={loginModal} sx={{ zIndex: 566000 }} className="app-login">
      <section className="section-1505">
        <Login isModal={true} />
        {!hideClose ? (
          <DIconButton onClick={onClose}>
            <CloseIcon color={Color.c666} width={30} height={30} />
          </DIconButton>
        ) : null}
      </section>
    </Modal>
  );
};

export default observer(AppLogin);
